import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import "leaflet/dist/leaflet.css"

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
})

export default class extends Controller {
  static values = { lat: Number, lng: Number, zoom: { type: Number, default: 14 } }

  connect() {
    this.map = L.map(this.element, { scrollWheelZoom: false })
      .setView([this.latValue, this.lngValue], this.zoomValue)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(this.map)

    L.marker([this.latValue, this.lngValue]).addTo(this.map)
  }

  disconnect() {
    if (this.map) this.map.remove()
  }
}
